import * as React from 'react';
import { pluralize } from '@cian/newbuilding-utils';
import { Header1, InlineText2 } from '@cian/ui-kit/typography';
import { useSelector } from 'react-redux';
import { Documents } from '../../components/Documents';
import { LinkList } from '../../components/LinkList';
import { ToggleButton } from '../../components/ToggleButton';
import { getDocuments } from '../../selectors/newbuilding';
import { trackDocumentClick } from './tracking';

const DESKTOP_VISIBLE_DOCUMENTS_LENGTH = 4;

export function DocumentsContainer() {
  const [isOpened, setOpenedState] = React.useState(false);
  const documents = useSelector(getDocuments);

  const visibleDocumentsLength = isOpened
    ? documents.length
    : documents.slice(0, DESKTOP_VISIBLE_DOCUMENTS_LENGTH).length;
  const hiddenDocumentsLength = documents.length - visibleDocumentsLength;
  const shouldShowButton = documents.length - DESKTOP_VISIBLE_DOCUMENTS_LENGTH > 0;

  const togglerText = isOpened
    ? 'Свернуть'
    : `Ещё ${pluralize(hiddenDocumentsLength, ['документ', 'документа', 'документов'])}`;

  const onChangeOpenedState = React.useCallback(() => setOpenedState(!isOpened), [isOpened, setOpenedState]);

  if (!documents.length) {
    return null;
  }

  return (
    <Documents
      header={
        <Header1 as="h2" fontWeight={'bold'}>
          Проектная документация
        </Header1>
      }
      list={<LinkList isOpened={isOpened} links={documents} cols={2} onLinkClick={trackDocumentClick} />}
      toggler={
        shouldShowButton ? (
          <ToggleButton onClick={onChangeOpenedState} isOpened={isOpened}>
            <InlineText2 color="primary_100">{togglerText}</InlineText2>
          </ToggleButton>
        ) : null
      }
    />
  );
}
